<template>
  <div class="main details">
    <!-- 项目信息 -->
    <div class="table-content" ref="quotation">
      <img class="logo" v-if="formState.showComp" src="@/assets/header.png" />
      <img class="logo" v-else src="@/assets/header-empty.png" />
      <div class="quotation">
        <span class="zh">报价单</span><span class="en">QUOTATION</span>
      </div>
      <div class="project-info">
        <div class="left">
          <p class="title">项目名称</p>
          <p class="project-name" v-if="preview" v-text="formState.projectName"></p>
          <a-input
            v-else
            class="project-name"
            v-model:value="formState.projectName"
          />
        </div>
        <div class="right">
          <p class="title">项目信息</p>
          <div class="right-item">
            <label>报价编号:</label>
            <span v-if="preview" v-text="formState.projectNum"></span>
            <a-input v-else v-model:value="formState.projectNum" />
          </div>
          <div class="right-item">
            <label>报价日期:</label>
            <span v-if="preview" v-text="formState.createDate"></span>
            <a-date-picker
              v-else
              v-model:value="formState.createDate"
              @change="changeDate"
            />
          </div>
          <div class="right-item">
            <label>联系方式:</label>
            <span v-if="preview" v-text="formState.phone"></span>
            <a-input v-else v-model:value="formState.phone" />
          </div>
        </div>
      </div>
      <div class="project-table">
        <a-table
          :pagination="false"
          :data-source="tableData"
          :columns="columns"
          :customRow="customRow"
          tableLayout="fixed"
          bordered
        >
          <template #no>
            <p>序号</p>
            <p>No.</p>
          </template>
          <template #type>
            <p>类型</p>
            <p>Type</p>
          </template>
          <template #func>
            <p>功能</p>
            <p>Functions</p>
          </template>
          <template #desc>
            <p>功能描述</p>
            <p>Description</p>
          </template>
          <template #cost>
            <p>人天</p>
            <p>Cost</p>
          </template>
          <template #total>
            <p>合计</p>
            <p>Total</p>
          </template>
        </a-table>
      </div>
      <img class="footer" src="@/assets/footer.png" />
      <img v-if="formState.showComp" v-show='preview' class="intr" src="@/assets/intr.png"/>
    </div>
    <!-- 查询条件表单 -->
    <div class="form">
      <div class="form-item" style="width: calc(100% - 56px)">
        <a-textarea
          v-model:value="aiMessage"
          placeholder="请直接输入功能描述或调整需求"
          :auto-size="{ minRows: 5, maxRows: 20 }"
        />
        <a-button class="btn" type="primary" style="float: right" @click="askAI" :loading="aiLoading">AI</a-button>
      </div>
      <!-- AI 响应展示区域 -->
      <div v-if="aiThinking || aiResponse" class="form-item ai-response-area" style="width: calc(100% - 56px)">
        <div v-if="aiThinking" class="ai-thinking">
          <div class="ai-section-title">💭 AI 思考中...</div>
          <div class="ai-content thinking-content">{{ aiThinking }}</div>
        </div>
        <div v-if="aiResponse" class="ai-output">
          <div class="ai-section-title">📝 AI 输出</div>
          <div class="ai-content">{{ aiResponse }}</div>
          <div class="ai-actions">
            <a-button type="primary" size="small" @click="applyAIResult">应用到报价单</a-button>
            <a-button size="small" @click="clearAIResponse">清除</a-button>
          </div>
        </div>
      </div>
      <div class="form-item">
        <label class="label" for="">人天单价:</label>
        <a-input-number
          v-model:value="formState.price"
          :formatter="value => `${value}元`"
          :parser="value => value.replace('元', '')"
        />
      </div>
      <div class="form-item">
        <label class="label" for="">开发工期:</label>
        <a-input-number
          v-model:value="formState.time"
          :formatter="value => `${value}天`"
          :parser="value => value.replace('天', '')"
        />
      </div>
      <div class="form-item">
        <label class="label" for="">人天系数:</label>
        <a-input-number
          v-model:value="formState.MPD"
          :min="100"
          :max="200"
          :formatter="value => `${value}%`"
          :parser="value => value.replace('%', '')"
        />
      </div>
      <div class="form-item">
        <label class="label" for="">维护费率:</label>
        <a-input-number
          v-model:value="formState.maintain"
          :min="0"
          :max="20"
          :formatter="value => `${value}%`"
          :parser="value => value.replace('%', '')"
        />
      </div>
      <div class="form-item">
        <label class="label" for="">服务器费:</label>
        <a-input-number
          v-model:value="formState.server"
          :formatter="value => `${value}元`"
          :parser="value => value.replace('元', '')"
        />
      </div>
      <div class="form-item">
        <label class="label" for="">税率:</label>
        <a-select class="select-item" v-model:value="formState.rate">
          <a-select-option :value="0">0%</a-select-option>
          <a-select-option :value="0.01">1%</a-select-option>
          <a-select-option :value="0.03">3%</a-select-option>
          <a-select-option :value="0.06">6%</a-select-option>
          <a-select-option :value="0.13">13%</a-select-option>
        </a-select>
      </div>
      <div class="form-item">
        <label class="label" for="">显示公司信息:</label>
        <a-select class="select-item" v-model:value="formState.showComp">
          <a-select-option :value="true">是</a-select-option>
          <a-select-option :value="false">否</a-select-option>
        </a-select>
      </div>
      <div class="form-item">
        <label class="label" for="">导出报价方式:</label>
        <a-select
          class="select-item"
          v-model:value="formState.displayMode"
          placeholder="按类型显示价格"
        >
          <a-select-option :value="0">按功能显示人天与价格</a-select-option>
          <a-select-option :value="1">按功能显示价格</a-select-option>
          <a-select-option :value="2">按类型显示人天与价格</a-select-option>
          <a-select-option :value="3">按类型显示价格</a-select-option>
        </a-select>
      </div>
      <div class="form-item">
        <label class="label" for="">导出形式:</label>
        <a-select class="select-item" v-model:value="formState.exportType">
          <a-select-option :value="0">PDF</a-select-option>
          <a-select-option :value="1">图片</a-select-option>
          <a-select-option :value="2">可分享链接</a-select-option>
        </a-select>
      </div>
      <div class="form-item">
        <label class="label" for="">预设密码:</label>
        <a-input v-model:value="formState.password" />
      </div>
      <div class="form-item">
        <label class="label" for="">有效期:</label>
        <a-input-number
          v-model:value="formState.warranty"
          :formatter="value => `${value}天`"
          :parser="value => value.replace('天', '')"
        />
      </div>
      <div class="form-item">
        <label class="label" for="">优惠:</label>
        <a-input-number
          v-model:value="formState.discount"
          :formatter="value => `${value}元`"
          :parser="value => value.replace('元', '')"
        />
      </div>
      <a-button class="btn" type="primary" @click="confirm">提交</a-button>
      <a-button class="btn" type="primary" @click="preview = !preview"
        >{{preview ? '编辑':'预览'}}</a-button
      >
      <a-button class="btn" type="primary" @click="exportFile">导出</a-button>
      <a
        style="display: none"
        ref="btn"
        :href="quationURL"
        :download="fileName + '.jpeg'"
      ></a>
      <a-button class="btn" type="primary">取消</a-button>
    </div>
  </div>

  <rightMenu :menu="menu" @add="addRow" @up="upRow" @down="downRow" @del="delRow" @cancel='menu.show = false' />
</template>
<script>
import { h } from "vue";
import { Input, notification, Button } from "ant-design-vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import rightMenu from '@/components/rightMenu'

const headMap = {
  no: 0,
  type: 1,
  func: 2,
  desc: 3,
  cost: 4,
  total: 5,
};

export default {
  components: {
    rightMenu
  },
  data() {
    return {
      preview: false,
      menu: {
        show: false,
        x: 0,
        y: 0,
      },
      table: null,
      target: null,
      targetName: 'quotation',
      aiMessage: '',
      aiLoading: false,
      aiThinking: '',
      aiResponse: '',
      aiResultData: null,
      chatMessage: [
        {"role": "system", "content": "你是一个专业的互联网软件产品经理"},
        {"role": "system", "content": `
          请你需要根据我给到的需求材料，整理需求清单。
          1、你需要以软件产品经理视角，交互设计视角，认真了解需求材料。
          2、你需要输出的需求要包括基本需求（如登陆注册等，材料中没提及但是系统完备需要的功能。），期望需求（材料中整理的需求）。
          3、限制：需要覆盖完整功能清单，但是不要发散，不增加额外需求。
          4、限制：需要逻辑完备闭环。
          5、限制：可以参考竞品。
          6、限制：输出以列表形式输出，分为模块（小程序端/后台管理端/网站前台端/设计/测试/部署等，根据需求需要选择）、功能、功能描述。
          7、需要符合政策，检查可实现性。如利用小程序文档检查所列功能是否可以实现，不可以实现的要去掉。如小程序内就不能实现支付宝支付了，如果一定要，那再另外提供方案。
          8、列出需求后，要将需求中注意的点也列出在描述内，如资质限制、门槛限制、风险限制等。
          请通过我的描述拆解需求，按我的格式要求输出中文报价单，格式要求为一个 json 数组串，你只需要直接提供这个 json 即可，无需有任何其他额外的内容，格式如下
            [{
              "type": "需求模块类型名称，如用户模块、订单模块、设计模块、测试模块等",
              "funcs": [
                {
                  "func": "功能名称",
                  "desc": "功能描述",
                  "cost": 0 # "数值，预估人天"
                }
              ]
            }...]
      `}],
      defaultState: {},
      quationURL: "",
      displayMode: 0, // 这个是预览及下载前需要判断的
      formState: {
        pid: "", // 主项目 ID
        projectName: "", // 项目名称
        projectNum: "", // 项目编号
        price: 1500, //人天单价
        time: "待定", //开发工期
        createDate: "", // 报价日期
        phone: "", // 联系方式
        MPD: 150, // 人天单价 Man Per Day
        maintain: 10, // 维护费率
        server: "待定", // 服务器费
        showComp: true, // 是否显示公司信息
        displayMode: 0, // 显示方式
        exportType: 0, // 导出方式
        password: "8888", // 密码
        warranty: 30, // 报价有效期
        discount: 0, //优惠
        rate: 0.01, // 税率
      },
      editKey: {},
      tableData: [
        {
          no: "1",
          type: "单击编辑",
          func: "右键增加类型或功能",
        },
        {
          onlyFix: true,
          no: `\n\n\n\n相关款项到账后 3 日乙方向甲方开具增值税普通发票。`,
        },
        {
          onlyFix: true,
          cost: "开发费",
        },
        {
          onlyFix: true,
          cost: "税费",
        },
        {
          onlyFix: true,
          cost: "优惠",
        },
        {
          onlyFix: true,
          cost: "总价",
        },
      ],
      columns: [
        {
          dataIndex: "no",
          align: "center",
          customRender: this.customRender("no"),
          width: 100,
          slots: {
            title: "no",
          },
        },
        {
          dataIndex: "type",
          customRender: this.customRender("type"),
          align: "center",
          width: 160,
          slots: {
            title: "type",
          },
        },
        {
          dataIndex: "func",
          customRender: this.customRender("func"),
          align: "left",
          width: 160,
          slots: {
            title: "func",
          },
        },
        {
          dataIndex: "desc",
          customRender: this.customRender("desc"),
          align: "left",
          slots: {
            title: "desc",
          },
        },
        {
          dataIndex: "cost",
          customRender: this.customRender("cost"),
          align: "center",
          width: 120,
          slots: {
            title: "cost",
          },
        },
        {
          dataIndex: "total",
          customRender: this.customRender("total"),
          align: "center",
          width: 120,
          slots: {
            title: "total",
          },
        },
      ],
    };
  },
  async mounted() {
    window.t = this; // TODO
    
    let id = this.$route.query.id;
    let currentPid = this.$route.query.pid || '';
    
    // 先获取报价单数据（如果是编辑模式）
    if (id) {
      this.target = await new this.$lc.Query(this.targetName)
        .equalTo("objectId", id)
        .first();
      this.formState = { ...this.target.attributes };
      this.defaultState = { ...this.target.attributes };
      this.tableData = this.formState.tableData;
    } else {
      this.formState.pid = this.$route.query.pid
      this.target = new this.$lc.Object(this.targetName);
      this.compute();
    }
    
    // 判断是否有草稿
    if (localStorage.tempTableData) {
        let tempDraft = JSON.parse(localStorage.tempTableData)
        let tempTableData = tempDraft.tableData || tempDraft // 兼容旧格式
        let draftPid = tempDraft.pid || ''
        
        // 获取当前项目 ID（新建模式用 query.pid，编辑模式用报价单的 pid）
        let targetPid = currentPid || this.formState.pid || ''
        let isSameProject = draftPid && targetPid && draftPid === targetPid
        
        // 只有当草稿属于当前项目时才提示恢复
        if (isSameProject) {
          let key = `open${Date.now()}`
          notification.open({
              message: '有未保存的草稿',
              description: '草稿仅保存表格部分，恢复后如需取消请刷新',
              btn: h(
                  Button,
                  {
                      type: 'primary',
                      size: 'small',
                      onClick: () => {
                          notification.close(key),
                          this.tableData = tempTableData
                      }
                  },
                  '恢复',
              ),
              key,
          })
        }
    }
  },
  watch: {
    tableData: {
      deep: true,
      // flush: 'post',
      handler() {
        this.compute();
        this.format();
        // 更新草稿（同时保存项目 ID，用于后续恢复时判断是否属于同一项目）
        localStorage.tempTableData = JSON.stringify({
          pid: this.formState.pid,
          tableData: this.tableData
        })
      },
    },
    formState: {
      deep: true,
      handler() {
        this.compute();
        this.format();
      },
    },
    preview(newVal) {
        this.displayMode = newVal ? this.formState.displayMode : 0
        this.compute();
        this.format();
    },
    displayMode(newVal) {
        if (newVal == 0 || newVal == 2) {
            delete this.columns[3].colSpan
            delete this.columns[4].colSpan
        } else {
            this.columns[3].colSpan = 2
            this.columns[4].colSpan = 0
        }
        
    }
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    fileName() {
        return `${this.formState.projectName} - 与或非科技 ${this.formState.createDate}`
    }
  },
  methods: {
    changeDate(date, dateString) {
      this.formState.createDate = dateString;
    },

    getDataset(e) {
      let { row, col } = e.target.dataset;
      row = parseInt(row);
      col = parseInt(col);
      return { row, col };
    },
 
    delTableData(idx) {
      this.tableData = this.tableData.filter((_, index) => idx != index);
    },
    async confirm() {
      // 校验数据
      if (typeof(this.formState.time) != 'number') {
        return this.$message.warn('工期未填写')
      }
      if (typeof(this.formState.server) != 'number') {
        return this.$message.warn('服务器费未填写')
      }
      
      let target = new this.$lc.Object(this.targetName);

      if (this.$route.query.pid) {
        // target.set("author", this.$user.get("username")); // TODO 校验是否正常
        // target.set("pid", this.$route.query.pid);
        target.set("version", 1);
        target.set("sourceVersion", 0);
      } else {
        // target.set("pid", this.target.pid);
        let lastTarget = await new this.$lc.Query(this.targetName)
          .equalTo("pid", this.target.get('pid'))
          .descending("version")
          .first();
        target.set("version", lastTarget.get("version") + 1);
        target.set("sourceVersion", this.target.get("version"));
      }
      this.formState.tableData = this.tableData;
      let formState = JSON.parse(JSON.stringify(this.formState));
      formState.tableData = this.tableData;
      delete formState.version;
      delete formState.sourceVersion;

      localStorage.removeItem('tempTableData') // 清除草稿
      this.$confirm(target, formState);
    },

    async format() {
      await this.$nextTick();
      console.log('开始格式化')
      // 清空斑马线
      let $stripe = document.querySelectorAll(".stripe");
      $stripe.forEach((i) => {
        i.classList.remove("stripe");
      });
      // 清空hide-td
      let $hideTd = document.querySelectorAll(".hide-td");
      $hideTd.forEach((i) => {
        i.classList.remove("hide-td");
      });

      let typeNo = 0
      this.tableData.map((item, idx) => {
        if (item.onlyType) {
          var $tds = document.querySelectorAll(`tr[data-row-key="${idx}"] td`);
          $tds.forEach((i, index) => {
            if (index == headMap["type"]) return;
            if (this.displayMode == 2 && [headMap["cost"], headMap["total"]].indexOf(index) != -1) return;
            if (this.displayMode == 3 && index == headMap["cost"]) return; // 因为少了一个 td 实际上 cost 为 total
            i.classList.add("hide-td");
          });
        }

        // 处理 Type 斑马线
        if (!item.onlyFunc) {
            if (typeNo % 2) {
                document.querySelector(`tr[data-row-key="${idx}"] td:nth-child(2)`)?.classList.add("stripe")
                document.querySelector(`tr[data-row-key="${idx}"] td:nth-child(5)`)?.classList.add("stripe")
                document.querySelector(`tr[data-row-key="${idx}"] td:nth-child(6)`)?.classList.add("stripe")
            }
            typeNo++
        }
        // 处理斑马线
        let no = item.no || 1;
        if (no % 2) return; // 单数无线
        $tds = document.querySelectorAll(`tr[data-row-key="${idx}"] td`);
        $tds.forEach((i, index) => {
          // if (index == 1) return;
          if (!item.onlyFunc && index == 1) return;
          i.classList.add("stripe");
        });
      });
    },

    async compute() {
      console.log('开始计算序号及总价')
      // await this.$nextTick();
      // 更新序号
      let no = 1;
      this.tableData.map((item, index) => {
        if (item.onlyType) return;
        if (index >= this.rows - 5) return;
        item.no = no++;
      })

      let total = 0
      let ratePrice = 0
      let cacheItem = {}
      this.tableData.map((item) => {
        if (item.onlyType) {
          cacheItem[item.id] = {
            type: item,
            cost: 0,
            total: 0
          }
          return
        }
        if (item.cost == "开发费")
          return (item.total = total);
        if (item.cost == "税费")
          return (item.total = ratePrice)
        if (item.cost == "优惠")
          return (item.total = this.formState.discount);
        if (item.cost == "总价")
          return (item.total =
            total +
            ratePrice -
            this.formState.discount);

        item.cost = parseFloat(item.cost) || 0;
        let itemTotal = parseFloat((item.cost * this.formState.MPD / 100 * this.formState.price).toFixed(2));

        // 计算 onlyType 的总人天及总价
        if (item.onlyFunc) {
          cacheItem[item.id].cost += item.cost
          cacheItem[item.id].total += itemTotal
        }

        total += itemTotal;
        item.total = itemTotal || '赠送'
        ratePrice = parseFloat((total * this.formState.rate).toFixed(2))
      });

      for (let idx in cacheItem) {
        let item = cacheItem[idx]
        if (this.preview && this.displayMode >= 2) {
          item.type.cost = item.cost
          item.type.total = item.total || '赠送'
        } else {
          delete item.type.cost
          delete item.type.total
        }
      }

      let remarkRow = this.tableData[this.rows - 5];
      let totalRow = this.tableData[this.rows - 1];
      remarkRow.no = `开发工期：${this.formState.time}个工作日；服务器： ${this.formState.server} 元/月；维护费：${(this.formState.maintain / 100 * totalRow.total / 12).toFixed(2)} 元/月。
项目验收后服务器费、维护费按季度或年度收取，服务器费视用量情况可做调整。
本报价单仅为开发费用，不含购买域名、第三方接口等费用；报价有效期 ${this.formState.warranty} 天，逾期请再次咨询。
请勿将此报价信息透露给报价单位及接收单位以外的人员。
${remarkRow.no.split("\n").slice(4).join("\n")}`;
    },

    customRow() {
      // enableEdit(record, index) {
      return {
        // 单击
        onClick: async (e) => {
          // console.log(record, index, event);
          let { row, col } = this.getDataset(e);
          // 序号不能编辑
          if (row <= this.rows - 6 && col == headMap["no"])
            return this.$message.warn("不可编辑");
          // 合计不能编辑
          if (row <= this.rows - 6 && col == headMap["total"])
            return this.$message.warn("不可编辑");
          // 合计标题不能编辑
          if (row >= this.rows - 4 && col == headMap["cost"])
            return this.$message.warn("不可编辑");
          // 合计结果不能编辑
          if (row >= this.rows - 4 && col == headMap["total"])
            return this.$message.warn("不可编辑");

          this.editKey[`${row}_${col}`] = 1;
          await this.$nextTick();
          let $textarea = e.target.querySelector("textarea")
          $textarea.focus();
          $textarea.select();
        },
        // 右键菜单
        onContextmenu: (e) => {
          let { row, col } = this.getDataset(e);
          if (isNaN(row)) return
          if (row >= this.rows - 5) return;
          if (col == headMap["no"]) return;
          e.preventDefault();

          this.menu.show = true;
          this.menu.x = e.clientX;
          this.menu.y = e.clientY;
          this.menu.row = row;
          this.menu.col = col;
          this.menu.target = this.tableData[row];
        },
      };
    },

    customRender(type) {
      let _type = type;
      return ({ text, record, index }, type = _type) => {
        let col = headMap[type];
        let row = index;
        const obj = {
          children: (() => {
            if (this.editKey[`${row}_${col}`]) {
              let autosize = "autosize";
              if (row == this.rows - 5 && col == headMap["no"]) {
                autosize = { minRows: 9, maxRows: 9 };
              }

              return h(Input.TextArea, {
                autosize,
                value: this.tableData[row][type],
                style: {
                  padding: '2px',
                  lineHeight: '32px',
                  textAlign: [headMap['type'], headMap['cost']].indexOf(col) != -1 && 'center', // type、cost 居中编辑
                },
                "onUpdate:value": (value) =>
                  (this.tableData[row][type] = value),
                onBlur: () => delete this.editKey[`${row}_${col}`],
              });
            }
            return text;
          })(),
          props: { "data-row": row, "data-col": col },
        };
        
        // console.log('开始计算单元格合并', '行', row, '列', col)
        // delete obj.props.colSpan
        // delete obj.props.rowSpan

        if (row < this.rows - 5) {
          let typeRowSpan = this.tableData.filter(i => i.onlyFunc && i.id == this.tableData[row].id).length + 1
          if (record.onlyType && headMap["type"] == col) {
            obj.props.rowSpan = typeRowSpan;
          }

          // 按功能显示人天和价格
          // if (this.displayMode == 0 && record.onlyFunc && col == headMap["type"]) {
          if (record.onlyFunc && col == headMap["type"]) {
            obj.props.colSpan = 0;
            obj.props.rowSpan = 0;
          }

          // 按功能显示价格
          if (this.displayMode == 1 && col == headMap["desc"]) {
            obj.props.colSpan = 2;
          }
          if (this.displayMode == 1 && col == headMap["cost"]) {
            obj.props.colSpan = 0;
            obj.props.rowSpan = 0;
          }

          // 按类型显示人天和价格
          if (this.displayMode == 2 && record.onlyType && [headMap["cost"], headMap["total"]].indexOf(col) != -1) {
            obj.props.rowSpan = typeRowSpan;
          }
          if (this.displayMode == 2 && record.onlyFunc && [headMap["cost"], headMap["total"]].indexOf(col) != -1) {
            obj.props.colSpan = 0;
            obj.props.rowSpan = 0;
          }

          // 按类型显示价格
          if (this.displayMode == 3 && col == headMap["desc"]) {
            obj.props.colSpan = 2;
          }
          if (this.displayMode == 3 && col == headMap["cost"]) {
            obj.props.colSpan = 0;
            obj.props.rowSpan = 0;
          }
          if (this.displayMode == 3 && record.onlyType && col == headMap["total"]) {
            obj.props.rowSpan = typeRowSpan;
          }
          if (this.displayMode == 3 && record.onlyFunc && [headMap["cost"], headMap["total"]].indexOf(col) != -1) {
            obj.props.colSpan = 0;
            obj.props.rowSpan = 0;
          }
        }

        // 处理表格尾部的 5 行(有一行只显示编辑备注)
        if (row >= this.rows - 5) {
          obj.props.colSpan = 0;
          obj.props.rowSpan = 0;
        }
        if (col == headMap["no"] && row == this.rows - 5) {
          obj.props.colSpan = 4;
          obj.props.rowSpan = 5;
        }
        if (col >= 4 && row >= this.rows - 4) {
          obj.props.colSpan = 1;
          obj.props.rowSpan = 1;
        }
        return obj;
      };
    },

    addRow() {
      if (this.menu.col == headMap["type"]) {
        let rowSpan = this.tableData.filter(i => i.onlyFunc && i.id == this.tableData[this.menu.row].id).length + 1;
        this.tableData.splice(this.menu.row + rowSpan, 0, {
          no: "1",
          type: "单击编辑",
        });
      } else {
        let step = 1;
        let id = new Date().getTime();
        if (
          this.menu.target.onlyFunc
          // && !this.tableData[this.menu.row].onlyType
        ) {
          id = this.menu.target.id;
        } else {
          this.menu.target.onlyFunc = true;
          this.menu.target.id = id;

          let oldType = this.menu.target.type;
          delete this.menu.target.type;

          step += 1;
          this.tableData.splice(this.menu.row, 0, {
            onlyType: true,
            type: oldType,
            id: id,
          });
        }

        this.tableData.splice(this.menu.row + step, 0, {
          onlyFunc: true,
          func: "单击编辑",
          id: id,
        });
      }
    },

    upRow() {
      if (this.menu.target.onlyFunc) {
        if (
          this.tableData
            .filter((item) => item.onlyFunc && item.id == this.menu.target.id)
            .shift() == this.menu.target
        ) {
          return this.$message.warn("该类型第一个功能不再允许上移");
        }

        this.tableData[this.menu.row] = this.tableData[this.menu.row - 1];
        this.tableData[this.menu.row - 1] = this.menu.target;
      } else {
        if (
          this.tableData
            .filter((item) => !item.onlyFunc && !item.onlyFix)
            .shift() == this.menu.target
        ) {
          return this.$message.warn("不再允许上移");
        }

        let cacheTabelData = [this.menu.target];
        if (this.menu.target.onlyType) {
          cacheTabelData = this.tableData.filter(
            (item) => item.id == this.menu.target.id
          );
        }

        let frontTarget = this.tableData[this.menu.row - 1];
        let cacheFrontTabelData = [frontTarget];
        if (frontTarget.onlyFunc) {
          cacheFrontTabelData = this.tableData.filter(
            (item) => item.id == frontTarget.id
          );
        }

        cacheTabelData.map((item, idx) => {
          this.tableData[this.menu.row - cacheFrontTabelData.length + idx] =
            cacheTabelData[idx];
        });

        cacheFrontTabelData.map((item, idx) => {
          this.tableData[
            this.menu.row -
              cacheFrontTabelData.length +
              cacheTabelData.length +
              idx
          ] = cacheFrontTabelData[idx];
        });
      }
    },
    downRow() {
      if (this.menu.target.onlyFunc) {
        if (
          this.tableData
            .filter((item) => item.id == this.menu.target.id)
            .pop() == this.menu.target
        ) {
          return this.$message.warn("该类型最后一个功能不再允许下移");
        }

        this.tableData[this.menu.row] = this.tableData[this.menu.row + 1];
        this.tableData[this.menu.row + 1] = this.menu.target;
      } else {
        if (
          this.tableData
            .filter((item) => !item.onlyFunc && !item.onlyFix)
            .pop() == this.menu.target
        ) {
          return this.$message.warn("不再允许下移");
        }
        let cacheTabelData = [this.menu.target];
        if (this.menu.target.onlyType) {
          cacheTabelData = this.tableData.filter(
            (item) => item.id == this.menu.target.id
          );
        }

        let nextTarget = this.tableData[this.menu.row + cacheTabelData.length];
        let cacheNextTabelData = [nextTarget];
        if (nextTarget.onlyType) {
          cacheNextTabelData = this.tableData.filter(
            (item) => item.id == nextTarget.id
          );
        }

        cacheNextTabelData.map((item, idx) => {
          this.tableData[this.menu.row + idx] = cacheNextTabelData[idx];
        });

        cacheTabelData.map((item, idx) => {
          this.tableData[this.menu.row + cacheNextTabelData.length + idx] =
            cacheTabelData[idx];
        });
      }
    },
    delRow() {
      if (this.menu.target.onlyType) {
        this.tableData = this.tableData.filter(
          (currentValue) => this.menu.target.id != currentValue.id
        );
      } else if (this.menu.target.onlyFunc) {
        this.delTableData(this.menu.row);

        let restNum = this.tableData.reduce((total, currentValue) => {
          if (
            currentValue.key == this.menu.target.key &&
            currentValue.onlyFunc
          ) {
            return total + 1;
          }
          return total;
        }, 0);

        // 合并 onlyType 和唯一的 onlyFunc
        let oldType = "";
        if (restNum == 1) {
          this.tableData.map((item, idx) => {
            if (item.id == this.menu.target.id && item.onlyType) {
              oldType = item.type;
              this.delTableData(idx);
            }
          });

          this.tableData.map((item) => {
            if (item.id == this.menu.target.id) {
              item.type = oldType;
              delete item.onlyFunc;
              delete item.id;
            }
          });
        }
      } else {
        this.delTableData(this.menu.row);
      }

      if (this.rows == 5) {
        this.tableData.unshift({
          no: "1",
          type: "单击编辑",
          func: "右键增加类型或功能",
        });
      }
    },
    // 导出
    async exportFile() {
      if (this.formState.exportType == 2) return this.$message.warn("功能开发中");

      let oldPreview = this.preview;
      this.preview = true;
      this.format() // 保险起见再更新一次
      await this.$nextTick();

      let dom = this.$refs.quotation;
      // let { clientWidth: width, clientHeight: height } = dom
      let { offsetWidth: width, offsetHeight: height } = dom

      let canvas = await html2canvas(dom, {
          width, //dom 原始宽度
          height,
          scale: 2,
      })

      if (this.formState.exportType == 0) {
        // let dpr = window.devicePixelRatio || 1
        const doc = new jsPDF({
          unit: 'px',
          format: [width, height],
          compress: true,
        });
        doc.addImage(canvas.toDataURL("image/jpeg"), 'jpeg', 0, 0, width, height)
        doc.link(0, height-2000, 500, 300, {url: 'https://yuhuofei.it/'});
        doc.link(500, height-2000, 500, 300, {url: 'http://cdn.yuhuofei.it/%E4%B8%8E%E6%88%96%E9%9D%9E%E7%A7%91%E6%8A%80%E4%BC%81%E4%B8%9A%E7%94%BB%E5%86%8C.pdf'});
        doc.save(this.fileName + '.pdf')
      }

      if (this.formState.exportType == 1) {
        this.quationURL = canvas.toDataURL("image/jpeg")
        await this.$nextTick();
        await this.$refs.btn.click();
      }


      // 切换回原预览状态
      this.preview = oldPreview;
    },

    async askAI() {
        if (!this.aiMessage) return this.$message.warn("请输入功能描述或调整需求");
        
        this.aiLoading = true;
        this.aiThinking = '';
        this.aiResponse = '';
        this.aiResultData = null;
        
        // 生成方便 AI 理解的内容
        let tableDataFormatted = []
        // 遍历 tableData 但是跳过最后 5 个
        for (let item of this.tableData.slice(0, -5)) {
          if (!item.onlyType && !item.onlyFunc) {
            tableDataFormatted.push({
              type: item.type,
              funcs: {
                func: item.func,
                desc: item.desc,
                total: item.total,
                cost: item.cost,
              }
            })
          }
          if (item.onlyType) {
            tableDataFormatted.push({
              type: item.type,
              funcs: []
            })
          }
          if (item.onlyFunc) {
            tableDataFormatted[tableDataFormatted.length - 1]['funcs'].push({
                func: item.func,
                desc: item.desc,
                total: item.total,
                cost: item.cost,
            })
          }
        }
        this.chatMessage.push(
            {"role": "system", "content": `
              这是现在的需求说明，需要基于这个数据来修改调整：
              ${JSON.stringify(tableDataFormatted)}
            `},
            {"role": "user", "content": `
              客户现在的需求：${this.aiMessage}
            `}
        )

        const apiUrl = 'https://ark.cn-beijing.volces.com/api/v3/chat/completions';
        const apiKey = '0df92fab-ff98-4c6b-9438-fc086b13341f'; 

        const requestBody = {
          "model": "doubao-seed-1-6-251015", 
          "messages": this.chatMessage
        };

    
        let AIResponse = ''
        try {
          const response = await fetch(apiUrl, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${apiKey}`
              },
              body: JSON.stringify(requestBody)
          });

          // 检查响应状态码
          if (!response.ok) {
              const errorText = await response.text();
              throw new Error(`API Request failed with status ${response.status}: ${errorText}`);
          }

          const result = await response.json();
          console.log("AI 响应结果:", result);
          
          // 提取并显示 AI 的回答内容
          if (result.choices && result.choices.length > 0) {
              const message = result.choices[0].message;
              
              // 显示思考过程（如果有）
              if (message.reasoning_content) {
                this.aiThinking = message.reasoning_content;
              }
              
              // 显示原始输出内容
              this.aiResponse = message.content;
              console.log("AI 的回答是:", message.content);
              this.chatMessage.push(message);
              
              // 尝试解析 JSON 结果
              try {
                AIResponse = JSON.parse(message.content);
                // 将AI返回转回原 tableData 的格式
                let tableData = []
                for (let item of AIResponse) {
                  if (item.funcs.length == 1) {
                    tableData.push({
                      type: item.type,
                      func: item.funcs[0].func,
                      desc: item.funcs[0].desc,
                      cost: item.funcs[0].cost,
                    })
                  }
                  if (item.funcs.length > 1) {
                    let id = Date.now() + Math.floor(Math.random() * 1000000)
                    tableData.push({
                      onlyType: true,
                      type: item.type,
                      id: id
                    })
                    for (let func of item.funcs) {
                      tableData.push({
                        onlyFunc: true,
                        func: func.func,
                        desc: func.desc,
                        cost: func.cost,
                        id: id
                      })
                    }
                  }
                }
                this.aiResultData = tableData;
              } catch (parseError) {
                console.error("JSON 解析失败:", parseError);
                this.$message.error("AI 返回格式有误，请查看输出内容");
              }
          }

        } catch (error) {
          console.error("AI请求发生错误:", error.message);
          this.$message.error("AI请求发生错误，请稍后重试");
          this.aiResponse = `请求失败: ${error.message}`;
        } finally {
          this.aiLoading = false;
        }
    },
    
    applyAIResult() {
      if (!this.aiResultData) {
        return this.$message.warn("没有可应用的结果");
      }
      // 赋值给 tableData 但是保留原来的后面 5 条数据
      this.tableData = [...this.aiResultData, ...this.tableData.slice(-5)];
      this.aiMessage = '';
      this.clearAIResponse();
      this.$message.success("已应用到报价单");
    },
    
    clearAIResponse() {
      this.aiThinking = '';
      this.aiResponse = '';
      this.aiResultData = null;
    }
  },
};
</script>
<style lang="scss">
.details table > tbody {
  td {
    white-space: pre-wrap;
  }
  tr:nth-last-child(5) > td:nth-child(1) {
    text-align: left !important;
    background: #fff;
  }
  tr:nth-last-child(4),
  tr:nth-last-child(2) {
    td:nth-child(1),
    td:nth-child(2) {
      background: #fff;
    }
  }
  tr:nth-last-child(3) td {
    background: #f7fafe;
  }
  tr:nth-last-child(1) td {
    color: #fff !important;
    background: #287fef !important;
    border-bottom: 3px solid #216ac8;
  }
}
.details {
  .ant-table-body {
    .ant-table-tbody {
      td {
        line-height: 32px;
      }
    }
    .ant-table-thead {
      th {
        font-weight: 700;
        line-height: 18px;
      }
    }
    th {
      color: #fff;
      background: #287fef;
      border-bottom: 3px solid #216ac8;
      font-size: 14px;
      font-weight: 700;
      p {
        margin: 0;
      }
    }
    th:nth-child(3),
    th:nth-child(4) {
      text-align: center !important;
    }
  }
  .right input {
    font-size: 14px;
    width: 220px;
    color: #0a033d;
  }
}
.hide-td {
  height: 0 !important;
  padding: 0 !important;
  border-bottom: none !important;
}
.stripe {
  background: #f7fafe;
}
</style>
<style scoped lang="scss">
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .table-content {
    width: 1000px;
    .logo {
      width: 100%;
    }
    .quotation {
      margin: 50px 0 0 41px;
      font-size: 46px;
      text-align: justify;
      color: #0a003e;
      line-height: 54px;
      .en {
        opacity: 0.19;
        font-weight: 700;
      }
    }
    .project-info {
      display: flex;
      justify-content: space-between;
      padding: 54px 40px 0;
      .left {
        min-width: 28em;
        color: #0a003e;
        .title {
          font-size: 18px;
          font-weight: 300;
          margin-bottom: 7px;
        }
        .project-name {
          font-size: 24px;
          font-weight: 600;
        }
      }
      .right {
        width: 320px;
        color: #0a003e;
        .title {
          font-size: 18px;
          font-weight: 300;
          margin-bottom: 14px;
        }
        .right-item {
          margin-top: 12px;
          line-height: 20px;
          font-weight: 600;
          label {
            margin-right: 26px;
          }
        }
      }
    }
    .project-table {
      margin-top: 130px;
      padding: 0 20px;
    }
    .footer {
      margin-top: 77px;
      width: 100%;
    }
    .intr {
      margin-top: 88px;
      width: 100%;
    }
  }

  .form {
    margin-top: 60px;
    padding: 20px 10px;
    width: 1000px;
    background-color: #266dc6;
    // text-align: center;
    align-items: flex-start;
    .form-item {
      margin: 10px 28px;
      width: 10em;
      display: inline-block;
      .label {
        color: white;
      }
      .ant-input-number, .select-item {
        width: 100%;
      }
    }

    .btn {
      margin: 20px 30px;
    }
    
    .ai-response-area {
      margin-top: 20px;
      
      .ai-section-title {
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
      }
      
      .ai-content {
        background: rgba(255, 255, 255, 0.95);
        border-radius: 8px;
        padding: 12px 16px;
        font-size: 13px;
        line-height: 1.6;
        white-space: pre-wrap;
        word-break: break-word;
        max-height: 300px;
        overflow-y: auto;
        margin-bottom: 12px;
      }
      
      .thinking-content {
        background: rgba(255, 255, 255, 0.85);
        color: #666;
        font-style: italic;
      }
      
      .ai-actions {
        display: flex;
        gap: 10px;
        margin-top: 8px;
      }
    }
  }
}
</style>
